import axios from 'axios'

export default axios.create({
  baseURL: 'https://jazeel-campaign-backend.halayalla.com/api/',
  // baseURL: 'https://jazeel-campaign-backend.halayalla.rocks/api/',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    Authorization: JSON.parse(localStorage.getItem('brandData:'))
      ? 'Bearer' + ' ' + JSON.parse(localStorage.getItem('brandData:'))?.token
      : JSON.parse(localStorage.getItem('userData:'))
      ? 'Bearer' + ' ' + JSON.parse(localStorage.getItem('userData:'))?.token
      : '',
  },
})
